import React, { Component } from 'react'
import { unitsService } from '../../_services/units.service'
import { Dropdown } from 'semantic-ui-react'
import { connect } from 'react-redux'
import unitTypes from '../../_constants/unitTypes'
import { da } from 'date-fns/locale'

class AsyncUnitSelect extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      defaultValue: this.props.defaultValue,
      unitType: undefined,
      data: [],
      exceptIds: this.props.exceptIds || undefined
    }
  }

  componentDidMount() {
    this.getUnitType()
  }

  getUnitType = () => {
    if (this.props.unitType !== undefined) {
      this.setState({ unitType: this.props.unitType }, () => {
        this.getData()
      })
    } else {
      const { user } = this.props
      let userType = parseInt(user.userType, 0)
      let unitType = undefined
      if (user && [4, 6, 8, 10].includes(userType)) {
        var unit = unitTypes.filter(el => el.userType === userType)[0]

        if (unit !== undefined) {
          unitType = unit.value
        }

        if (unitType !== undefined) {
          this.setState({ unitType: unitType }, () => {
            this.getData()
          })
        } else {
          this.getData()
        }
      } else {
        this.getData()
      }
    }
  }

  getData = () => {
    this.setState({ loading: true })
    unitsService
      .getAll(this.state.unitType)
      .then(res => {
        // console.log(res.data);

        let data = res.data.map(elm => ({ text: elm.name, value: elm.id }))

        if (this.state.exceptIds) {
          let dt = data
          dt = dt.filter(el => !this.state.exceptIds.includes(el.value))
          data = dt
        }

        this.setState({ data: data, loading: false, isSubmitting: false })
      })
      .catch(error => {
        this.setState({ loading: false })
        // console.log(error)
      })
  }

  async componentWillReceiveProps(nextProps) {
    // console.log(nextProps.defaultValue);

    if (nextProps.defaultValue !== this.state.defaultValue) {
      this.setState({ defaultValue: nextProps.defaultValue })
    }

    if (nextProps.unitType && nextProps.unitType !== this.state.unitType) {
      this.setState({ unitType: nextProps.unitType }, () => {
        this.getData()
      })
    }

    if (nextProps.exceptIds && nextProps.exceptIds !== this.state.exceptIds) {
      this.setState({ exceptIds: nextProps.exceptIds }, () => {
        this.getData()
      })
    }
  }

  handleChange = e => {
    let selected = e
    this.setState({ selected: selected })
    this.props.onChange(selected, this.state.unitType)
  }

  render() {
    const { data, loading, defaultValue, disabled } = this.state
    const { clearable, className } = this.props

    return (
      <Dropdown
        placeholder=""
        fluid
        search
        selection
        basic
        onChange={(e, data) => this.handleChange(data.value)}
        value={defaultValue}
        className={className}
        options={data}
        wrapSelection={false}
        selectOnBlur={false}
        searchInput={{ autoFocus: false }}
        loading={loading}
        disabled={disabled}
        clearable={clearable}
        noResultsMessage="در حال بارگزاری"
      />
    )
  }
}

function mapStateToProps(state) {
  const { authentication } = state
  const { user } = authentication
  return {
    user
  }
}

const connectedAsyncUnitSelect = connect(mapStateToProps)(AsyncUnitSelect)
export { connectedAsyncUnitSelect as AsyncUnitSelect }
